import React from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import 'bootstrap-icons/font/bootstrap-icons.css';

function SharedNavbar() {
  return (
    <Navbar expand="lg" fixed="top" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="https://przelyczki.org.pl/" target='_blank'>
          <img
            src={`${process.env.PUBLIC_URL}/images/logo-01.png`}
            height="70"
            className="d-inline-block align-top"
            alt="React Bootstrap logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="me-auto">
            <Nav.Link href="/#o_konferencji">O WYDARZENIU</Nav.Link>
            <Nav.Link href="/#program">PROGRAM</Nav.Link>
            <Nav.Link href="/#wykladowcy">PRELEGENCI</Nav.Link>
            <Nav.Link href="/#kontakt">KONTAKT</Nav.Link>
          </Nav>
          <Navbar.Text>
            <Nav.Link href="/#rejestracja">
              <Button className="registerButton">
                <i className="bi bi-pencil-square"></i> REJESTRACJA
              </Button>
            </Nav.Link>
          </Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default SharedNavbar;
